import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const PORTALS = [
  { slug: "punto-nima", name: "Punto Nima", sub: "San José del Cabo · 5th-floor condo" },
  { slug: "casa-de-leon", name: "Casa de León", sub: "Punta Arena · Cabo San Lucas villa" },
];

export default function AdminPortals() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  useEffect(() => { if (user === false) nav("/admin/login"); }, [user, nav]);
  if (!user || !user.email) return <div className="min-h-screen bg-[#F6F4F0]" />;

  return (
    <div className="min-h-screen bg-[#0F2537] text-[#F6F4F0]" data-testid="admin-portals">
      <header className="px-6 lg:px-10 py-5 flex items-center justify-between border-b border-white/10">
        <div>
          <span className="font-display text-xl tracking-[0.12em]">DERRON LUXURY · Owner Portals</span>
          <p className="text-[#A3A09A] text-xs mt-0.5">{user.email}</p>
        </div>
        <button data-testid="logout-button" onClick={async () => { await logout(); nav("/admin/login"); }}
          className="flex items-center gap-2 text-sm text-[#A3A09A] hover:text-white transition-colors">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </header>

      <div className="max-w-[1000px] mx-auto px-6 lg:px-10 py-20">
        <span className="text-[#E4B58C] text-xs tracking-[0.3em] uppercase">Choose a property to manage</span>
        <h1 className="font-display font-light text-4xl sm:text-5xl mt-4 mb-12">Which residence today?</h1>
        <div className="grid sm:grid-cols-2 gap-6">
          {PORTALS.map((p) => (
            <button key={p.slug} data-testid={`portal-${p.slug}`} onClick={() => nav(`/admin/${p.slug}`)}
              className="group text-left bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 hover:border-[#B86B52]/60 rounded-sm p-8 transition-all">
              <div className="font-display text-3xl">{p.name}</div>
              <p className="text-[#A3A09A] font-light mt-2">{p.sub}</p>
              <span className="inline-flex items-center gap-2 mt-8 text-sm text-[#E4B58C] group-hover:gap-3 transition-all">
                Manage this property <ArrowRight className="w-4 h-4" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
